<template>
  <div class="container" v-loading="loading">
    <div class="part">
      <p class="title">产品详情</p>
      <ul class="partContent">
        <li><span class="pcTitle">产品名称：</span><span class="pcContent">{{

            productName.indexOf("A") > -1?"学驾易(驾考服务)A": productName.indexOf("C") > -1?"学驾易(驾考服务)C": "学驾易(驾考服务)"   }}</span></li>
      </ul>
    </div>
    <!--    <div class="part">-->
    <!--      <p class="title">驾校信息</p>-->
    <!--      <ul class="partContent">-->
    <!--        <li><span class="pcTitle">驾校名称：</span><span class="pcContent">{{ dsName }}</span></li>-->
    <!--        <li><span class="pcTitle">统一社会信用代码：</span><span class="pcContent">{{ dsSocialCode }}</span></li>-->
    <!--      </ul>-->
    <!--    </div>-->
    <div class="operate">
      <div class="photo" data-type="1">
        <p class="title">证件照上传</p>
        <ul class="h5Camera">
          <li class="front">
            <span class="title">身份证正面</span>
            <van-uploader
              v-model="fileListFront"
              preview-size="100px"
              :after-read="(file)=>{afterRead(file, 1)}"
              :before-read="beforeRead"
              @delete="(file)=>{deletePhoto(file, 2)}"
              :max-count="1"/>
          </li>
          <li class="behind">
            <span class="title">身份证反面</span>
            <van-uploader
              v-model="fileListBack"
              preview-size="100px"
              :after-read="(file)=>{afterRead(file, 2)}"
              :before-read="beforeRead"
              @delete="(file)=>{deletePhoto(file, 2)}"
              :max-count="1"/>
          </li>
        </ul>
      </div>
      <!--        <el-button type="primary"  icon="el-icon-circle-plus-outline" size="small" @click="addStudent">添加学员</el-button>-->
      <!--        <div class="uploadDiv">-->
      <!--          <el-upload-->
      <!--            action="/"-->
      <!--            accept=".xlsx, .xls"-->
      <!--            :before-upload="beforeUpload"-->
      <!--            :auto-upload="true"-->
      <!--            multiple-->
      <!--            ref="upload"-->
      <!--            :limit="1"-->
      <!--            :file-list="fileList"-->
      <!--          >-->
      <!--            <el-button size="small" type="primary" icon="el-icon-upload2" >导入学员</el-button>-->
      <!--          </el-upload>-->
      <!--        </div>-->
      <!--        <el-link type="primary" :href="downloadFile" target="_blank" style="margin-left: 20px;">下载模板</el-link>-->
      <!--        <el-link type="primary" href="/static/order_tpml.xlsx" target="_blank" style="margin-left: 20px;">下载模板</el-link>-->
      <!--        <p class="tips">温馨提示：模版里的头部【姓名、身份证、手机号】不能去掉，提交前请核实条数。</p>-->
    </div>
    <div class="part">
      <p class="title">学员信息</p>
      <ul class="partContent partContentLong">
        <li v-for="(item, index) in studentList" :key="index">
          <!--          <p style="width: 40px;text-align: center;">{{ index + 1 }}</p>-->
          <p>姓名：<input  type="text" v-model="item.name" maxlength="20" placeholder="请输入姓名"></p>
          <p >身份证号：<input  type="text" class="width200" v-model="item.cardId" maxlength="18" placeholder="请输入身份证号"></p>
          <p >手机号：<input   type="tel" v-model="item.mobile" maxlength="21" placeholder="请输入手机号"></p>
        </li>
      </ul>

    </div>
    <p class="agreement" :class="{'checked':agreeState}" @click="toAgree"><i></i>我已阅读并同意
      <br/> <span
        @click.stop="toRule(1)">《投保须知》</span><br/><span
        @click.stop="toRule(2)">《服务协议》</span><br/><span
        @click.stop="toRule(3)">《客户告知书》</span><br/></p>
    <p class="feeTip">需支付总金额：￥<span>{{ totalFee }}</span></p>
    <div style="width:  100%;text-align: center">
      <!--      <el-button type="primary" size="small" @click="submit('ALP')">支付宝支付</el-button>-->
      <el-button style="width: 60%" type="success" size="small" @click="submit('WXP')">微信支付</el-button>
    </div>
    <van-dialog v-if="payDialogVisible" v-model="payDialogVisible" :title="`请使用${paymentTitle}`" :show-cancel-button="false" :show-confirm-button="false">
      <van-image v-if="payDialogVisible" :src="payImgUrlList[0]" style="width: 80%;margin: 20px 10% 20px 10%" />
    </van-dialog>
    <van-dialog v-if="dialogVisibleProtocol" v-model="dialogVisibleProtocol" title="" :show-cancel-button="true" :show-confirm-button="false">
      <tbxz v-if="ruleTypes == 1"></tbxz>
      <fwxy v-else-if="ruleTypes == 2"></fwxy>
      <khgzs v-else></khgzs>
    </van-dialog>
  </div>
</template>

<script>
import {Config} from "../../components/common/api";
import {Toast} from "vant";
import tbxz from "../rules/tbxz.vue";
import fwxy from "../rules/fwxy.vue";
import khgzs from "../rules/khgzs.vue";
export default {
  name: "toubaoView",
  components:{
    tbxz,fwxy,khgzs
  },
  data() {
    return {
      fileListFront: [], //身份证正面
      fileListBack: [], //身份证反面面
      getStatusTemp:null,
      hasData:false,
      agreeState: false, // 是否同意协议
      paymentTitle:'微信支付',
      studentList: [{
        name: '',
        cardId: '',
        mobile: '',
      }], // 学员信息
      downloadFile: '', // 下载模板
      fileList: [],
      singleFee: 0, // 单个费用
      totalFee: '0.00', // 支付总金额
      payDialogVisible: false, // 支付弹框
      fileListPay: [], // 支付截图
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      headers: {}, // 请求头
      uploadUrl: Config.api_url + 'applets-server/api/minio/upload/niu.pay',
      dialogVisiblePay: false,
      dialogVisibleProtocol: false,
      payImgUrlList: [],
      productId: '',
      productName: '',
      dsName: '',
      dsSocialCode: '',
      ruleTypes: 1,
      loading:true,
    };
  },
  mounted() {
    let query = this.$route.query;
    if (query.token){
      localStorage.setItem("token",query.token)
    }
    this.headers = {'Authorization': localStorage.getItem('token')};
    this.productId = this.$route.query.productId || '0';
    this.init();
    //待支付数据拉取
    // this.waitPayList();
  },
  methods: {
    // 上传前
    deletePhoto(file, type) {
      const url = Config.api_url + "applets-server/api/minio/remove/cert";
      const that = this;
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          fileName: file.img
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.ajaxState = true;
        const data = res.data;
        if (data.success) {

        } else {
          Toast(data.errorMessage || '接口失败，请重试！');
        }
      }).catch(function (err) {
        Toast('网络异常，请重试！');
      });
    },
    // 上传前
    beforeRead(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.resizeCount = 1;
        Toast('图片大小不能超过10M');
        return false;
      }
      return true;
    },
    // 上传后
    afterRead(file, type) {
      console.log(file);
      const url = Config.api_url + 'applets-server/api/minio/upload/cert/image';
      const that = this;
      let config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      let formdata = new FormData();
      let canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
      let context = canvas.getContext('2d');
      let img = new Image();
      img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
      console.log('0', file.content.length / 1024);
      const imageSize = file.content.length || 100;
      if (imageSize <= 10 * 1024 * 1024 && imageSize > 8 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 8 * 1024 * 1024 && imageSize > 6 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 6 * 1024 * 1024 && imageSize > 4 * 1024 * 1024) {
        this.resizeCount = 2.5;
      } else if (imageSize <= 4 * 1024 * 1024 && imageSize > 2 * 1024 * 1024) {
        this.resizeCount = 1.5;
      } else {
        this.resizeCount = 1;
      }
      console.log(this.resizeCount);
      img.onload = () => {
        if (this.resizeCount > 1) {
          canvas.width = img.width / this.resizeCount;
          canvas.height = img.height / this.resizeCount;
          context.drawImage(img, 0, 0, img.width / this.resizeCount, img.height / this.resizeCount);
          file.content = canvas.toDataURL(file.file.type, 1);
        }
        let files = this.dataURLtoFile(file.content, file.file.name);
        formdata.append('file', files);
        console.log('1', file.content.length / 1024);
        formdata.append('token', localStorage.getItem('infoToken'));
        this.$ajax.post(url, formdata, config).then(function (res) {
          const data = res.data;
          if (data.success) {
            if (type == '1') {
              that.fileListFront[0].img = data.data;
              //  访问后台接口，进行数据读取
              that.loading = true
              that.$ajax({
                method: "post",
                url: Config.api_url + `applets-server/api/order/getIdCardInfo`,
                data:{
                  url:that.fileListFront[0].img
                },
                headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
              }).then(function (res) {
                if (res.data.success && res.data.data !='' && res.data.data != null){
                  that.studentList[0].name = res.data.data.name
                  that.studentList[0].cardId = res.data.data.idNum
                  that.loading = false
                }else {
                  that.$message({
                    type:'error',
                    message:"身份证识别失败！"
                  })
                  that.loading = false
                }
              }).catch((e)=>{
                {
                  console.log(e)
                  that.loading = false
                }
              })

            } else {
              that.fileListBack[0].img = data.data;
            }
          } else {
            Toast(data.errorMessage || '接口失败，请重试！');
            if (type == '1') {
              that.fileListFront = [];
            } else {
              that.fileListBack = [];
            }
          }
        }).catch(function (err) {
          if (type == '1') {
            that.fileListFront = [];
          } else {
            that.fileListBack = [];
          }
          Toast('网络异常，请重试！');
        });
      }
    },
    // 将base64转换为file文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    // 初始化
    init() {
      const that = this;
      this.$ajax({
        method: "get",
        url: Config.api_url + `applets-server/api/policyPc/init/${this.productId}`,
        headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
      }).then(function (res) {
        const resData = res.data;
        if (resData.success) {
          const productMap = resData.data.productMap || {};
          that.downloadFile = productMap.templateUrl || '';
          that.singleFee = productMap.productFee || 0;
          that.totalFee = that.singleFee;
          that.payImgUrlList = (productMap.payUrl || '').split(',');
          that.productName = productMap.productName || '';
          const schoolMap = resData.data.schoolMap || {};
          that.dsName = schoolMap.dsName || '';
          that.dsSocialCode = schoolMap.dsSocialCode || '';
          // that.studentList = resData.data.students != '' && resData.data.students != null && resData.data.students.length === 1 ?resData.data.students: [{
          //   name: '',
          //   cardId: '',
          //   mobile: '',
          // }];
          //
          // if (that.studentList != null && that.studentList.length ==1 && that.studentList[0].positiveImage) {
          //   that.fileListFront = [{
          //     url: that.studentList[0].positiveImage,
          //     img: that.studentList[0].positiveImage
          //   }];
          // }
          // if (that.studentList != null && that.studentList.length ==1 &&that.studentList[0].negativeImage) {
          //   that.fileListBack = [{
          //     url: that.studentList[0].negativeImage,
          //     img: that.studentList[0].negativeImage
          //   }];
          // }
          // if (that.studentList != '' && that.studentList != null && that.studentList.length > 0){
          //   that.hasData = true;
          // }else{
          //   that.hasData = false;
          // }

          that.loading = false
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(err => {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    // 同意协议
    toAgree() {
      this.agreeState = !this.agreeState;
    },
    // 查看协议
    toRule(type) {
      this.dialogVisibleProtocol = true;
      this.ruleTypes = type;
    },
    // 删除学员
    delStudent(index) {
      this.studentList.splice(index, 1);
    },
    // 添加学员
    addStudent() {
      const newStu = {
        name: '',
        cardId: '',
        mobile: '',
      };
      this.studentList.push(newStu);
    },
    beforeUpload(file) {
      const that = this;
      const _file = file;
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          for (let sheet in workbook.Sheets) {
            // 循环读取每个文件
            const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
            // 若当前sheet没有数据，则continue
            if (sheetArray.length == 0) {
              continue;
            }
            //解析返回的json
            for (let stu in sheetArray) {
              const thisStu = sheetArray[stu];

              const newStu = {
                name: thisStu['姓名'],
                cardId: thisStu['身份证'],
                mobile: thisStu['手机号'],
              };
              that.studentList.push(newStu);
            }
          }
        } catch (e) {
          this.$message.warning('文件类型不正确！')
        }
      };
      fileReader.readAsBinaryString(_file);
    },
    // 电话号码格式校验
    checkMobiles(number) {
      return /^((1)+\d{10})$/.test(number);
    },
    // 数据校验
    checkData() {
      const that = this;
      if (this.fileListFront == [] || this.fileListBack.length == 0){
        that.$message({
          type: "error",
          message: `身份证正面照不能为空`,
          offset: 300
        });
        return false;
      }
      if (this.fileListBack == [] || this.fileListBack.length == 0){
        that.$message({
          type: "error",
          message: `身份证反面照不能为空`,
          offset: 300
        });
        return false;
      }
      for (let stu in this.studentList) {
        const student = this.studentList[stu];
        //身份证去空
        // if (this.studentList[stu]['cardId']){
        //
        //   this.studentList[stu]['cardId'] = this.studentList[stu]['cardId'].trim()
        // }
        const index = parseInt(stu) + 1;
        if (student.name == '') {
          that.$message({
            type: "error",
            message: `第${index}学员信息填写错误：请填写学员姓名!`,
            offset: 300
          });
          return false;
        } else if (student.mobile == '') {
          that.$message({
            type: "error",
            message: `第${index}学员信息填写错误：请填写手机号!`,
            offset: 300
          });
          return false;
        } else if (!that.checkMobiles(student.mobile)) {
          that.$message({
            type: "error",
            message: `第${index}学员信息填写错误：手机号码格式有误，请重新输入!`,
            offset: 300
          });
          return false;
        } else if (student.cardId == '') {
          that.$message({
            type: "error",
            message: `第${index}学员信息填写错误：请填写身份证号!`,
            offset: 300
          });
          return false;
        }
      }
      return true;
    },
    // 提交
    submit(type) {


      this.paymentTitle = type == 'ALP'?"支付宝支付":"微信支付"
      if (!this.agreeState) {
        this.$message({
          type: "error",
          message: '请先勾选协议',
          offset: 300
        });
        return;
      }
      if (!this.checkData()) {
        return;
      }
      let params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      params.students[0].positiveImage=this.fileListFront[0].img
      params.students[0].negativeImage=this.fileListBack[0].img
      params.type = type;
      if (window.wx && window.wx.miniProgram) {
        window.wx.miniProgram.postMessage({
          data: {
            type: 'requestPayment',
            payload: {
              orderId: params.students[0].orderId,  // 订单号
              price: this.totalFee
            }
          }
        });
      }
      const that = this;
      this.$ajax({
        method: "post",
        url: Config.api_url + 'applets-server/api/policyPc/pre/check',
        data: {
          ...params
        },
        headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
      }).then(function (res) {
        const resData = res.data;
        if (resData.success) {
          that.payDialogVisible = true;
          //支付二维码
          that.payImgUrlList = [resData.data.url]
          //开始进行实时获取状态
          //  进行身份证保存 params.students[0].cardId
          that.$ajax({
            method: "post",
            url: Config.api_url + 'applets-server/api/policyPc/saveFile',
            data: {
              negativeImage:params.students[0].negativeImage,
              orderId:params.students[0].orderId,
              positiveImage:params.students[0].positiveImage
            },
            headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
          }).then(function (res) {

          })
          that.getStatus(resData.data.orderId)
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '接口异常，请重试！',
            offset: 200
          });
        }
      }).catch(err => {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    getStatus(orderId){
      let that = this;
      // 定时任务读取状态
      clearInterval(this.getStatusTemp);
      this.getStatusTemp = setInterval(()=>{
        this.$ajax({
          method: "get",
          url: Config.api_url + 'applets-server/api/payment/getInfo/'+orderId,
          headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
        }).then(function (res) {
          if (res.data.status == 1){
            that.payDialogVisible = false;
            that.nowPay();
            clearInterval(that.getStatusTemp)
          }
        })
      },1000)
    },
    // 保存接口
    policySave(type) {
      let params = {};
      params.productId = this.productId;
      params.students = this.studentList;
      if (type) {
        params.payImage = this.fileListPay[0].url;
      }
      console.log(params);
      const that = this;
      this.$ajax({
        method: "post",
        url: Config.api_url + 'applets-server/api/policyPc/save',
        data: {
          ...params
        },
        headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')}
      }).then(function (res) {
        const resData = res.data;
        if (resData.success) {
          that.$message({
            type: "success",
            message: '提交成功',
            offset: 200
          });
          that.payDialogVisible = false;
          that.$router.go(-1);
        } else {
          that.$message({
            type: "error",
            message: resData.errorMessage || '未查询到数据，请重试！',
            offset: 200
          });
        }
      }).catch(err => {
        that.$message({
          type: "error",
          message: '网络失败，请重试！',
          offset: 200
        });
      });
    },
    // 上传文件前
    beforeUploadPay(file) {
      const FileExt = file.name.replace(/.+\./, "");
      if (['png', 'jpg', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          message: '仅支持JPG、PNG格式文件',
          type: 'warning',
          offset: 200
        });
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message({
          type: "warning",
          message: "上传文件的大小不能超过10M",
          offset: 200
        });
        return false;
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '正在上传中。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    onSuccessPay(response, file, fileList) {
      console.log(response);
      console.log(file);
      if (response.success) {
        this.fileListPay = [
          {
            name: file.name,
            url: response.data
          }
        ];
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
      } else {
        this.uploadLoading.close();
        this.$refs.upload.clearFiles();
        this.$message({
          type: "error",
          message: response.errorMsg,
          offset: 200
        });
      }

    },
    onErrorPay(file, fileList) {
      this.uploadLoading.close();
      this.$refs.upload.clearFiles();
      this.$message({
        type: "error",
        message: '文件上传失败，请重试！',
        offset: 200
      });
    },
    handleRemove(file) {
      this.fileListPay = [];
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 已支付
    nowPay() {

      this.payDialogVisible = false;
      this.studentList=[]
      this.$router.push("/")

      //TODO 支付完不需要入库了，自动回调入库
      // if (this.fileListPay.length == 0) {
      //   this.$message({
      //     type: "error",
      //     message: '请先上传已付证明！',
      //     offset: 200
      //   });
      //   return;
      // }
      // this.policySave(1);
    },
    // 稍后支付
    waitPay() {
      this.policySave();
    },
  },
  watch: {

    '$route'(to, from) {
      console.log("to",to,from)
      if (to.query.productId && (to.query.productId !== from.query.productId)) {
        this.studentList = []
        this.totalFee = '0.00'
        this.productId = this.$route.query.productId || '0';
        this.init();
      }
    },
    'studentList': {
      handler(v) {
        const len = v.length;
        this.totalFee = len * this.singleFee;
      },
      deep: true
    },
  }
}

</script>
<style lang="scss">
.hidden-el-upload--picture-card {
  .el-upload--picture-card {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
$them: #5783ff;
$themGrey: #595959;

.container {
  font-size: 14px;
  color: #595959;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
}

.part {
  line-height: 40px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ececec;
  margin-bottom: 15px;

  .title {
    color: $them;
  }

  .partContent {
    line-height: 40px;
    overflow: hidden;

    li {
      //width: 49%;
      float: left;
      margin-bottom: 10px;

      .pcTitle {
        display: inline-block;
        margin-right: 10px;
      }

      .pcContent {
        display: inline-block;
      }

      & > p {
        //width: 30%;
        float: left;
        height: 40px;

        input {
          display: inline-block;
          width: 140px;
          height: 32px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #d8d8d8;
          padding: 4px 6px 4px 10px;
        }

        .width200 {
          width: 200px;
        }
      }

      .delete {
        cursor: pointer;
      }
    }

    &.partContentLong {
      max-height: 300px;
      overflow: auto;

      li {
        width: 100%;
      }
    }
  }

  .operate {
    padding: 10px 0;

    .uploadDiv {
      display: inline-block;
    }

    .tips {
      display: inline-block;
      color: #ff0000;
      font-size: 12px;
      margin-left: 10px;
    }
  }
}

.agreement {
  margin: 0 0 15px;
  padding-left: 18px;
  line-height: 20px;
  font-size: 16px;
  color: #333;
  position: relative;
  white-space: nowrap;
  cursor: pointer;
  vertical-align: middle;

  i {
    width: 16PX;
    height: 16PX;
    border: 1PX solid #ccc;
    box-sizing: border-box;
    border-radius: 100%;
    margin-right: 4px;
    margin-bottom: -2px;
    display: inline-block;
    position: relative;
  }

  &.checked {
    i {
      border: 1PX solid $them;

      &:after {
        position: absolute;
        content: '';
        z-index: 1;
        width: 10PX;
        height: 10PX;
        background: $them;
        top: 2px;
        left: 2px;
        border-radius: 100%;
      }
    }
  }

  span {
    color: $them;
  }
}

.feeTip {
  margin: 20px 0;
  color: #ff0000;
  font-size: 14px;
  padding-left: 18px;

  span {
    font-size: 16px;
    font-weight: bold;
  }
}

.dialogContent {
  position: relative;

  .payImgDiv {
    overflow: hidden;

    .payImg {
      display: inline-block;
      width: 200px;
      height: auto;
      margin-right: 10px;
    }
  }

  .payTips {
    margin: 20px 0;
    color: #ff0000;
    font-size: 14px;
    text-align: center;

    span {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .scalePayImg {
    position: absolute;
    right: 10px;
    top: 125px;
    font-size: 14px;
    width: 100px;

    span {
      display: block;
      color: $them;
      font-size: 16px;
      cursor: pointer;
    }
  }
}

.uploadPayImg {
  overflow: hidden;

  .inTitle {
    display: block;
    padding-right: 11px;
    box-sizing: border-box;
    height: 32px;
    line-height: 32px;
    color: #ff0000;

    i {
      font-style: normal;
      color: #ff0000;
    }
  }

  .upImgList {
    display: block;
    overflow: hidden;
    padding-top: 10px;
  }
}
.photo {
  padding: 12px 0;
  min-height: 130px;
  position: relative;
  border-top: 1px solid #eeeeee;
  margin-top: 10px;
  > .title {
    margin-bottom: 10px;
    color: #2486ff;
  }
  ul {
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      position: relative;
      width: 36%;
      text-align: center;
      float: left;
      background-size: 34px;
      height: 106px;
      margin-bottom: 10px;
      margin-left: 1.16%;
      margin-right: 1.16%;
      .title {
        display: block;
        color: #2486ff;
        font-size: 14px;
        margin-bottom: 5px;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// toubaoStudent.vue?0b505854